import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-ricorso-gerarchico-view',
  templateUrl: './form-ricorso-gerarchico-view.component.html',
  styleUrls: ['./form-ricorso-gerarchico-view.component.css']
})
export class FormRicorsoGerarchicoViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
